import { render, staticRenderFns } from "./Method.vue?vue&type=template&id=a7dc07b8&scoped=true&"
import script from "./Method.vue?vue&type=script&lang=js&"
export * from "./Method.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dc07b8",
  null
  
)

export default component.exports